<template>
  <div class="p-mb-2">
    <div class="p-grid" style="margin: 0">
      <div class="p-col maxwidth">
        <img
          width="64px"
          style="transform: scale(1.75);padding-left: 5px;"
          src="../public/assets/layout/images/pmg-shops.png"
        />
        <img
          width="220px"
          style="padding-left: 7px"
          src="../public/assets/layout/images/pmg-logo-white.png"
        />
      </div>

      <div class="p-col">
        <div class="p-grid p-jc-end p-mt-3 p-mr-3">
          <!-- <img class="pointer" @click="onLogout()" width="26" :src="require('../public/assets/layout/images/pmg-userprofile.png')" /> -->
          <div id="system-name" style="margin-left: 10px" class="pointer"><p @click="onLogout()">{{ username }}</p></div>
          <div id="system-name" style="margin-left: 10px" class="pointer"><p @click="onLogout()">:</p></div>
          <div id="system-name" style="margin-left: 10px" class="pointer"><p @click="onLogout()">ออกจากระบบ</p></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    topbarMenuActive: Boolean,
    horizontal: Boolean,
    activeTopbarItem: String,
  },
  data() {
    return {
      collapsedImage: false,
      icon: "",
      style: "",
      username: "",
    };
  },
  mounted() {
    if (localStorage.getItem("userSession") != null) {
      this.username = localStorage.getItem("userSession");
      this.collapsedImage = true;
      this.icon = "pi pi-chevron-down";
      this.style = "height:0px";
    } else {
      this.collapsedImage = false;
      this.icon = "pi pi-chevron-up";
      this.style = "";
    }
  },
  methods: {
    onMenuButtonClick(event) {
      this.$emit("menubutton-click", event);
    },
    onTopbarMenuButtonClick(event) {
      this.$emit("topbar-menubutton-click", event);
    },
    onLogout()
    {
      localStorage.removeItem('userSession');
      window.location = "/"
    },
  },
  computed: {},
};
</script>
<style scoped>
#system-name {
  color: white;
  font-size: 16px;
}
#system-name-org {
  color: white;
  font-size: 14px;
}

.maxwidth {
  max-width: max-content;
}

.line {
  padding-bottom: 3px;
  border-bottom-style: solid;
  border-bottom-width: 2.5px;
  width: fit-content;
}
</style>
